<template>
  <div class="sales-note-list">
    <div ref="header">
      <search-input
        v-model="keyword"
        :typeList="typeList"
        :placeholder-word="placeholder"
        @on-search="search"
        @on-type-change="selectTypeChange">
      </search-input>
    </div>

    <div class="list-wrapper" v-show="salesNoteList.length">
      <scroller
        lock-x
        scrollerbar-y
        use-pullup
        ref="scroller"
        :height='scrollerHeight'
        :pullup-config="{content:'',upContent:'加载中...',downContent:'',loadingContent:'加载中...'}"
        @on-pullup-loading="loadMoreNotes"
      >
        <div>
          <ul class="list-item" v-for="(noteItem,index) in salesNoteList" :key="index">
            <sales-note-item
              :noteItem='noteItem'
              @on-item-click="gotoDetail"
            >
            </sales-note-item>
            <span class="bottom-border"></span>
          </ul>
          <divider class="bottom-line"  v-if="salesNoteList.length > 10 && loadCompleted">我是有底线的</divider>
        </div>
      </scroller>
    </div>
    <div class="no-car-wrapper" v-if="!salesNoteList.length && !isLoad">
      <img src="../../stylesheets/images/icon/no-vehicwle-icon.jpg" class="no-car-img" />
      <div class="description">无客户信息</div>
    </div>
    <img class="add-more" @click.stop="gotoAddPage" src="../../stylesheets/images/add-more.png" alt="">
  </div>
</template>

<script>
import SalesNoteItem from '../components/SalesNoteItem'
import SearchInput from '../components/SearchInput'
import { Divider, Scroller } from '@lx-frontend/cvux'
const camelCase = require('lodash.camelcase')

export default {
  components: {
    SalesNoteItem,
    SearchInput,
    Divider,
    Scroller
  },
  data() {
    return {
      salesNoteList: [],
      page: 1,
      count: 10,
      keyword: '',
      loadCompleted: false, // 标识列表项是否加载完成
      placeholder: '支持模糊匹配',
      currentType: 'plate_number',
      typeList: [
        { value: 'plate_number', title: '车牌号', placeholder: '支持模糊匹配' },
        { value: 'customer_mobile', title: '手机号', placeholder: '请输入完整手机号' }
      ],
      scrollerHeight: '',
      isLoad: false
    }
  },
  created () {
    this.getNoteList()
  },
  mounted () {
    this.scrollerHeight = `-${this.$refs.header.offsetHeight}px`
  },
  methods: {
    search() {
      this.page = 1
      this.loadCompleted = false
      this.salesNoteList = []
      this.$nextTick(() => {
        this.$refs.scroller.reset({ top: 0 })
        this.getNoteList()
      })
    },
    selectTypeChange(val) {
      const selectedItem = this.typeList.find(item => item.value === val)
      if (!selectedItem) return
      this.currentType = selectedItem.value
      this.placeholder = selectedItem.placeholder
    },
    gotoDetail(customerId) {
      this.$router.push({
        path: '/carregister/record',
        query: { customerId }
      })
    },
    gotoAddPage() {
      this.$router.push({
        path: '/carregister/addRegister'
      })
    },
    loadMoreNotes(done) {
      this.page++
      this.getNoteList()
      done()
    },
    getNoteList(loadingFlag) {
      if (this.loadCompleted) return
      const params = {
        page: this.page,
        count: this.count,
        [this.currentType]: this.keyword
      }
      this.isLoad = true
      this.$rest.carRegister.getSalesNoteList(params)
        .then(res => {
          if (res.code === 0) {
            const newNoteList = this.camelCaseObj(res.data).customerInfos
            this.salesNoteList = [...this.salesNoteList, ...newNoteList]
            const listLength = this.salesNoteList.length
            this.$nextTick(() => { this.$refs.scroller.reset() })
            if (res.data.total_count <= listLength) {
              this.loadCompleted = true
              this.$nextTick(() => { this.$refs.scroller.disablePullup() })
            } else {
              this.loadCompleted = false
              this.$nextTick(() => { this.$refs.scroller.enablePullup() })
            }
          } else {
            this.showToast(res.message)
          }
        }).finally(() => {
          this.isLoad = false
        })
    },
    camelCaseObj(obj) {
      if (!obj) return null
      const keys = Object.keys(obj)
      const newObj = {}
      for (let key of keys) {
        if (Array.isArray(obj[key])) {
          newObj[camelCase(key)] = obj[key].map(item => {
            return typeof item === 'string' ? item : this.camelCaseObj(item)
          })
        } else if (typeof obj[key] === 'object') {
          newObj[camelCase(key)] = this.camelCaseObj(obj[key])
        } else {
          newObj[camelCase(key)] = obj[key]
        }
      }
      return newObj
    }
  }
}
</script>

<style lang="less" scoped>
@w2: 75rem;
.sales-note-list {
  .list-wrapper{
    .list-item:not(:last-child) {
      position: relative;
      .bottom-border {
        position: absolute;
        bottom: 0;
        left: 30/@w2;
        width: 100%;
        height: 0px;
        border-top: #e7e7e9 solid 1px;
        @media screen and (-webkit-min-device-pixel-ratio: 2) {
          transform: scaleY(0.5);
        }
      }
    }
  }
  .bottom-line {
    width: 100%;
    padding: 20/@w2 30%;
    box-sizing: border-box;
  }
  .no-car-wrapper {
    text-align: center;
    margin-top: 200/@w2;
    .no-car-img {
      width: 175/@w2;
      height: 175/@w2;
    }
    .description {
      font-size: 30/@w2;
      color: #000000;
      opacity: 0.4;
    }
  }
  .add-more{
    position: fixed;
    bottom: 76/@w2;
    right: 40/@w2;
    width: 96/@w2;
    height: 96/@w2;
  }
}
</style>
